interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
  breadcrumbs?: Array<{ name: string; url: string }>;
  faqs?: Array<{ question: string; answer: string }>;
  articleData?: {
    headline: string;
    description: string;
    datePublished: string;
    dateModified: string;
    authorName: string;
    imageUrl?: string;
    url: string;
  };
}

export default function SchemaOrg({ type, breadcrumbs, faqs, articleData }: SchemaOrgProps) {
  const baseUrl = 'https://www.juzishipin.com';

  const getSchema = (): Record<string, unknown> => {
    switch (type) {
      case 'Organization':
        return {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '桔子视频',
          url: baseUrl,
          description: '桔子视频收录91视频网站、久久视频等热门视频资源，91在线视频高清免费在线观看，菠萝视频同步更新，电视剧全集电影大全流畅不缓冲。',
          sameAs: [baseUrl],
        };

      case 'WebSite':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '桔子视频',
          url: baseUrl,
          description: '桔子视频收录91视频网站、久久视频等热门视频资源，91在线视频高清免费在线观看，菠萝视频同步更新。',
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: `${baseUrl}/category/all?q={search_term_string}`,
            },
            'query-input': 'required name=search_term_string',
          },
        };

      case 'WebPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '桔子视频 - 首页',
          url: baseUrl,
          description: '桔子视频收录91视频网站、久久视频等热门视频资源，91在线视频高清免费在线观看，菠萝视频同步更新。',
          isPartOf: {
            '@type': 'WebSite',
            name: '桔子视频',
            url: baseUrl,
          },
        };

      case 'BreadcrumbList':
        return {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: (breadcrumbs || []).map((crumb, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: crumb.name,
            item: `${baseUrl}${crumb.url}`,
          })),
        };

      case 'Article':
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: articleData?.headline || '',
          description: articleData?.description || '',
          datePublished: articleData?.datePublished || '',
          dateModified: articleData?.dateModified || '',
          author: {
            '@type': 'Organization',
            name: articleData?.authorName || '桔子视频',
          },
          image: articleData?.imageUrl || '',
          url: articleData?.url || '',
          publisher: {
            '@type': 'Organization',
            name: '桔子视频',
          },
        };

      case 'FAQPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: (faqs || []).map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        };

      default:
        return {};
    }
  };

  const schema = getSchema();

  if (Object.keys(schema).length <= 1) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
}